<template>
  <div 
    :class="[$style.root, $style[type], $style[size]]">
    {{ text }}
  </div>
</template>

<script>
 
export default {
  name: 'Badge',

  props: {
    text: String,
    type: {
      type: String,
      default: 'success'
    },
    size: {
      type: String,
      default: 'medium'
    }
  }

}

</script>

<style module>

.root {  
  @apply
    inline-flex 
    items-center 
    px-3 
    rounded-lg 
    text-xs 
    font-medium 
    leading-6
  }

  .success {
    @apply
      border-success
      text-white
      bg-success
  }

  .warning {
    @apply
      border-warning
      text-white
      bg-warning
  }

  .danger {
    @apply
      border-danger
      text-white
      bg-danger
  }

  .primary {
    @apply
      border-primary
      text-primary
  }
 
  .small {
    @apply
      text-xs
  }

</style>
